const SuccessLegend: React.FC = () => {
  return (
    <section className="flex flex-col gap-1 px-4">
      <h2 className="text-body-sm text-neutral-fg">شانس موفقیت</h2>
      <div className="flex gap-4 text-body-sm text-gray-08">
        <span className="flex items-center gap-1">
          <span className="size-2.5 rounded-full bg-green-grass" aria-hidden />
          زیاد
        </span>
        <span className="flex items-center gap-1">
          <span className="size-2.5 rounded-full bg-yellow-pale" aria-hidden />
          متوسط
        </span>
        <span className="flex items-center gap-1">
          <span className="size-2.5 rounded-full bg-pink-light" aria-hidden />
          کم
        </span>
      </div>
    </section>
  );
};

export default SuccessLegend;
